const botUserAgentStringSnippets = ['pinterest'];

const checkUserAgentForBot = (userAgent: string = '') => {
    if (typeof userAgent === 'string') {
        if (new RegExp(botUserAgentStringSnippets.join('|')).test(userAgent.toLowerCase())) {
            return true;
        }
    }
    return false;
};

export default checkUserAgentForBot;
